import script from "./declined-vendors.vue?vue&type=script&setup=true&lang=js"
export * from "./declined-vendors.vue?vue&type=script&setup=true&lang=js"

import "./declined-vendors.vue?vue&type=style&index=0&id=35a99c5f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a99c5f"]])

export default __exports__